import { EntitySelect, EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import { WorkflowTeamSelectorDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { EntitySelectorComponent } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'

const TeamSelector: EntitySelectorComponent = ({
  value,
  onChange,
  error,
  disabled,
  placeholder,
}) => {
  const { data, loading: teamsLoading } = useQuery(WorkflowTeamSelectorDocument)

  const availableTeams = data?.teams?.teamsConnection?.nodes || []
  const selectedTeam = value ? availableTeams.find((team) => team.id === value) : undefined
  const selectedEntities = selectedTeam
    ? [{ id: selectedTeam.id, name: selectedTeam.name, avatar: buildUrl(selectedTeam.avatar) }]
    : []

  return (
    <EntitySelect
      label={i18n.t('workflows.sidepanel.approval.strategies.selectors.teams')}
      hideLabel
      loading={teamsLoading}
      disabled={disabled}
      entities={availableTeams.map(({ id, avatar, name }) => ({
        avatar: buildUrl(avatar),
        expanded: false,
        id,
        name,
      }))}
      notFoundSubtitle={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_not_found_subtitle'
      )}
      notFoundTitle={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_not_found_title'
      )}
      onGroupChange={() => {}}
      onItemExpandedChange={() => {}}
      onSelect={(selection: EntitySelectEntity | null) => {
        onChange(selection?.id ?? null)
      }}
      searchPlaceholder={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_search_placeholder'
      )}
      selectedEntities={selectedEntities}
      selectedLabel={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_selected_label'
      )}
      singleSelector
      size="md"
      placeholder={
        placeholder || i18n.t('workflows.sidepanel.approval.strategies.selectors.teams_placeholder')
      }
      selectedItemsCopy={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_selected_copy'
      )}
      groups={[]}
      selectedGroup="all"
      clearLabel={i18n.t('workflows.sidepanel.approval.strategies.selectors.teams_clear_label')}
      selectAllLabel={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.teams_select_all_label'
      )}
      error={error}
    />
  )
}

export default TeamSelector
